import { IOnlineOrderingSettings } from "../models/data.interface";

/** Store listing from Setting 274's app banner IDs; null when the platform's ID isn't set. */
export function getAppStoreUrl(settings: IOnlineOrderingSettings, isIos: boolean): string | null {
    const storeId = isIos ? settings.appBannerAppStoreId : settings.appBannerPlayStorePackageName;
    if (!storeId)
        return null;

    return isIos
        ? `https://apps.apple.com/app/id${encodeURIComponent(storeId)}`
        : `https://play.google.com/store/apps/details?id=${encodeURIComponent(storeId)}`;
}
